'use strict';

var chunkV6YUYBTJ_js = require('./chunk-V6YUYBTJ.js');
var chunk32OAM7MJ_js = require('./chunk-32OAM7MJ.js');
var A = require('react');
var E = require('clsx');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var A__default = /*#__PURE__*/_interopDefault(A);
var E__default = /*#__PURE__*/_interopDefault(E);

var S=A__default.default.forwardRef(({linkText:m,variant:t="link",linkUrl:f,linkMetaTitle:c,color:n,linkType:e,target:o,className:d,buttonStyle:p="primary",hideIcon:l,onClick:k,dataTestId:x,...u},L)=>{let _=`${chunk32OAM7MJ_js.a}-link`,g=o||"_self",r=t==="button",w=E__default.default(_,d,p,t,{"link-external":!r&&e==="open_in_new","link-internal":!r&&e==="arrow_forward","link-file":!r&&e==="file_download"});return jsxRuntime.jsxs("a",{href:f,onClick:k,className:w,style:{color:n},target:g,"aria-label":c,ref:L,"data-testid":x,...u,children:[!l&&e!=="open_in_new"&&t!=="button"&&jsxRuntime.jsx(chunkV6YUYBTJ_js.b,{name:e,size:"sm",fill:n,referenceSize:"link"}),jsxRuntime.jsx("span",{style:{color:n},children:m}),!l&&e==="open_in_new"&&jsxRuntime.jsx(chunkV6YUYBTJ_js.b,{name:e,size:"sm",fill:n,referenceSize:"link"})]})}),b=S;

exports.a = b;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-75FJ3E4W.js.map